module.exports = __webpack_public_path__ + "static/media/wizard-mode-visual.c4b36185.png";